export enum EnumStorage {
	UTM = 'sessionUtm',
	LEAD_ID = 'publicAutofinLeadId',
	ADDRESS_VALUES = 'creditasAddressPageValues',
	REJECTED_REASONS = 'publicAutofinRejectedReasons',
}